import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { ButtonDropdown } from "@bitcine/cs-theme"
import { can, VIEW_SCREENER_ANALYTICS } from "@helpers/authorization"
import { GLOBALS } from "@src/config"

class Export extends React.Component {
  export(format) {
    let { parentType, parentID } = this.props
    window.open(
      `${GLOBALS.API_URL}/shared-screeners/export?parentType=${parentType}&parentID=${parentID}&format=${format}`,
      "_blank"
    )
  }
  render() {
    if (!this.props.canViewAnalytics) return null
    return (
      <ButtonDropdown
        button={{
          text: "Export",
          className: "white small ml1"
        }}
        dropdown={{
          clickCloses: true,
          content: [
            {
              text: "Export Reviewers as CSV",
              icon: "bar_chart",
              onClick: () => this.export("csv"),
              show: true
            },
            {
              text: "Export Reviewer Sessions as XLSX",
              icon: "grid_on",
              onClick: () => this.export("xlsx"),
              show: true
            },
            {
              text: "Export Reviewers as PDF",
              icon: "picture_as_pdf",
              onClick: () => this.export("pdf"),
              show: this.props.parentType === "screener"
            },
          ].filter(opt => opt.show)
        }}
      />
    )
  }
}

Export.propTypes = {
  parentType: PropTypes.string,
  parentID: PropTypes.string,
  canViewAnalytics: PropTypes.bool
}

const mapStateToProps = state => ({
  parentType: state.shared_screeners.query.parentType,
  parentID: state.shared_screeners.query.parentID,
  canViewAnalytics: can(state.user.auth, [VIEW_SCREENER_ANALYTICS]),
  orgID: state.user.auth.organization_id,
  screenerRoomID: state.screener_rooms.screenerRoom.data._id,
  projectID: state.project.details._id,
})

export default connect(mapStateToProps)(Export)
